import React from 'react';
import { useMiniTimer } from '../contexts/MiniTimerContext.tsx';
import { useTimer } from '../contexts/TimerContext.tsx';
import './Header.css';

interface HeaderProps {
  onSettingsClick: () => void;
  onStatsClick: () => void;
}

const Icon: React.FC<{ d: string }> = ({ d }) => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d={d} />
  </svg>
);

const BrandLockup: React.FC = () => (
  <a className="kf-brand" href="/" aria-label="KairoFocus, home">
    <svg className="kf-symbol" width="26" height="26" viewBox="0 0 200 200" aria-hidden="true" focusable="false">
      <circle className="kf-face" cx="100" cy="100" r="84" fill="none" stroke="currentColor" strokeWidth="9" />
      <circle className="kf-dot" cx="100" cy="16" r="18" />
      <line className="kf-hand" x1="100" y1="100" x2="100" y2="34" strokeWidth="9" strokeLinecap="round" />
      <circle className="kf-core" cx="100" cy="100" r="10" />
    </svg>
    <span className="kf-wordmark">
      Kairo<span className="kf-dot-inline" aria-hidden="true" />Focus
    </span>
  </a>
);

const Header: React.FC<HeaderProps> = ({ onSettingsClick, onStatsClick }) => {
  const { isMiniTimerVisible, toggleMiniTimer } = useMiniTimer();
  const { handleReset } = useTimer();

  return (
    <header className="topbar">
      <BrandLockup />
      <div className="actions">
        <button className="action-btn" data-active={isMiniTimerVisible} onClick={toggleMiniTimer}>
          <span className="ico"><Icon d="M3 5h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2zm10 8h6a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-6" /></span>
          <span className="btn-label">Mini Timer</span>
        </button>
        <button className="action-btn" onClick={onStatsClick}>
          <span className="ico"><Icon d="M4 20V10M10 20V4M16 20v-7M22 20H2" /></span>
          <span className="btn-label">Stats</span>
        </button>
        <button className="action-btn" onClick={handleReset}>
          <span className="ico"><Icon d="M3 12a9 9 0 1 0 3-6.7M3 4v5h5" /></span>
          <span className="btn-label">Reset</span>
        </button>
        <button className="action-btn" onClick={onSettingsClick}>
          <span className="ico"><Icon d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm7.4-3a7.4 7.4 0 0 0-.1-1.4l2-1.5-2-3.5-2.4 1a7.4 7.4 0 0 0-2.4-1.4l-.4-2.5h-4l-.4 2.5a7.4 7.4 0 0 0-2.4 1.4l-2.4-1-2 3.5 2 1.5a7.4 7.4 0 0 0 0 2.8l-2 1.5 2 3.5 2.4-1a7.4 7.4 0 0 0 2.4 1.4l.4 2.5h4l.4-2.5a7.4 7.4 0 0 0 2.4-1.4l2.4 1 2-3.5-2-1.5c0-.5.1-.9.1-1.4z" /></span>
          <span className="btn-label">Settings</span>
        </button>
      </div>
    </header>
  );
};

export default Header;
